module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "col-xs-offset-2 col-xs-8",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticClass: "btn text-uppercase",
    attrs: {
      "id": "check-btn"
    },
    on: {
      "click": _vm.check
    }
  }, [_vm._v("Check")]), _vm._v(" "), _c('a', {
    staticClass: "btn text-uppercase",
    attrs: {
      "id": "create-btn"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Kobe Tech Team")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a445c26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Development/Express-Gateway/User/index.vue
// module id = 2017
// module chunks = 0